import { type CSSProperties } from 'react';

interface ColorPaletteProps {
    colorName: string;
    pmsValue: string;
    hexValue: string;
    cmykValue: string;
    rgbValue: string;
    backgroundColor: CSSProperties['background'];
    fontColor: CSSProperties['color'];
}

export const ColorPalette = ({
    colorName,
    pmsValue,
    hexValue,
    cmykValue,
    rgbValue,
    backgroundColor,
    fontColor,
}: ColorPaletteProps) => (
    <div
        className="sds_color-palette__container"
        style={{ background: backgroundColor, color: fontColor }}
    >
        <div className="sds_color-palette__container__name">{colorName}</div>
        <div className="sds_color-palette__container__value">PMS {pmsValue}</div>
        <div className="sds_color-palette__container__value">HEX {hexValue}</div>
        <div className="sds_color-palette__container__value">CMYK {cmykValue}</div>
        <div className="sds_color-palette__container__value">RGB {rgbValue}</div>
    </div>
);
